import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

import ProfileNavigateAvatar from '@elements/ProfileNavigateAvatar'
import FloatingButton from '@elements/FloatingButton'
import { PiCaretRightBold } from 'react-icons/pi'

const ButtonFloat = styled(FloatingButton)`
  padding: ${size(1)} ${size(0.5)} ${size(1)} ${size(1)};
  height: auto;
  z-index: 1;
`

const Spacer = styled.div`
  width: ${size(3)}
`

const TextWithPostCount = styled.span`
  font-size: ${fontSize('sm')};
`

const styles = (isAvatar=false) => ({
  avatarStyles: {
    height: size(3.25),
    width: size(3.25),
    filter: isAvatar && 'grayscale(100%) contrast(120%)'
  },
  linkStyles: {
    display: 'inline-block',
    position: 'absolute',
    top: '50%',
    left: size(0.5),
    transform: 'translateY(-50%)',
    border: '1px solid rgba(255,255,255, 0.15)',
    borderRadius: 100,
  }
})

const SocialNearbyProfileButton = ({ isAboveAnchor, onNavigate, thumbnailSrc, buttonText, isAvatar, postCount }) => {

  const renderText = () => {
    // if (typeof postCount === 'number' && postCount > 0) {
    //   return (
    //     <TextWithPostCount>
    //       {postCount} posts
    //     </TextWithPostCount>
    //   )
    // } else {
      return (buttonText)
    // }
  }

  return (
    <ButtonFloat
      style={{
        marginRight: size(1),
        backgroundColor: !isAboveAnchor && '#333333',
      }}
      // NOTE: We want to backnavigate if we navigated from the nearby profile so we don't get stuck in looped backnavigation later
      onClick={onNavigate}>
      {thumbnailSrc &&
        <>
          <Spacer />
          <ProfileNavigateAvatar
            allowEventPropogation
            canNavigate={false}
            src={thumbnailSrc}
            style={styles(isAvatar).avatarStyles}
            linkProps={{ style: styles().linkStyles }}
          />
        </>
      }
      &nbsp;
      {renderText()}
      <PiCaretRightBold size={size(2.5)} />
    </ButtonFloat>
  )
}

// NOTE: Some test layout for a post count display on the social button
//       BUT.. It might be better to put this somehwere else if it's too hard to read on the button.
// {/* <div> */}
//   {buttonText}
//   {/* Social<br /> */}
//   {/* <span style={{ fontSize: 8, fontWeight: 800 }}>99+ Posts</span> */}
// {/* </div> */}

export { SocialNearbyProfileButton }
